import { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';

// redux
import { Store } from '../../../redux/root';

// hooks
import { useCachedTotalPendingVolunteers } from 'hooks/volunteers/useCachedTotalPendingVolunteers';

// components
import TabNavItem from 'shared/components/TabNav/TabNavItem';
import TabNav from 'shared/components/TabNav';

// types
import { VOLUNTEER_TABS } from './types';

// styles
import styles from './VolListContent.module.scss';

type StoreManagementTabsProps = {
	activeTab: VOLUNTEER_TABS;
	// eslint-disable-next-line no-unused-vars
	setActiveTab: (tab: VOLUNTEER_TABS) => void;
};

const VolunteerTabs: FC<StoreManagementTabsProps> = ({ activeTab, setActiveTab }) => {
	const history = useHistory();
	const location = useLocation();

	const volunteersRecordsTotal = useSelector((store: Store) => store.volunteersRedux.volunteers.total);
	const pendingVolunteersTotal = useCachedTotalPendingVolunteers();

	useEffect(() => {
		if (location.search.includes('pending-approval')) setActiveTab(VOLUNTEER_TABS.PENDING_APPROVAL);
	}, [location.search]);

	useEffect(() => {
		if (!location.search) history.push({ search: '?store' });
	}, []);

	return (
		<TabNav>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={VOLUNTEER_TABS.ALL}
				activeTab={activeTab === VOLUNTEER_TABS.ALL}
				counter={volunteersRecordsTotal}
				clickHandler={() => {
					history.push({ search: '' });
					setActiveTab(VOLUNTEER_TABS.ALL);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={VOLUNTEER_TABS.PENDING_APPROVAL}
				activeTab={activeTab === VOLUNTEER_TABS.PENDING_APPROVAL}
				counter={pendingVolunteersTotal}
				clickHandler={() => {
					history.push({ search: '?pending-approval' });
					setActiveTab(VOLUNTEER_TABS.PENDING_APPROVAL);
				}}
			/>
		</TabNav>
	);
};

export default VolunteerTabs;
